import React from "react";
import { FiLinkedin, FiFileText } from "react-icons/fi";
import LanguageSwitcher from "./LanguageSwitcher";

function Topbar() {
  return (
    <header className="topbar container">
      <h1 className="brand">
        Mouad <span className="brand__light">Kasmi</span>
      </h1>

      <div className="topbar__actions">
        <LanguageSwitcher />
        <div className="social">
          <a href="https://www.linkedin.com/in/mouad-kasmi-523448304/" className="icon-link" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FiLinkedin />
          </a>
          <a href="/assets/Werkwijze.pdf" className="icon-link" download aria-label="Download CV">
            <FiFileText />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Topbar;
